
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"plugin"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PluginPayload"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"pluginManifest"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"pluginEntrypoints"},"directives":[]}]}}],"loc":{"start":0,"end":147}};
    doc.loc.source = {"body":"#import './pluginManifest.gql'\n#import './pluginEntrypoints.gql'\n\nfragment plugin on PluginPayload {\n  ...pluginManifest\n  ...pluginEntrypoints\n}\n\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('./pluginManifest.gql').definitions));
doc.definitions = doc.definitions.concat(unique(require('./pluginEntrypoints.gql').definitions));


      module.exports = doc;
    
